import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Header, Menu, Footer } from '../../components'
import './not-found.scss'

class NotFound extends Component {
  render() {
    return (
      <>
        <Header />
        <div className="container-lg p-0">
          <Menu />
        </div>
        <div className="ch-not-found">
          <div className="container">
            <div className="ch-not-found-box">
              <h1 className="display-1 text-center">!Oops</h1>
              <h4 className="text-center">We're sorry...</h4>
              <h4 className="text-center">Error 404 Page Not Found</h4>
            </div>
          </div>
        </div>
        <Footer />
      </>
    )
  }
}

export default withRouter(NotFound)
